// extracted by mini-css-extract-plugin
export default {"dashboard":"styles_dashboard__fjL02","content":"styles_content__iq0Tq","content--collapsed":"styles_content--collapsed__SwnH3"};